import React, { useState } from "react";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white py-20 md:py-28" aria-labelledby="faq-title" data-id="element-104" data-mp="1lbiqykv2vnor">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 md:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-105" data-mp="1l9fqt807oe6b">
        <div data-id="element-106" data-mp="2e0fxjqpxfw1o">
          <h2 id="faq-title" className="font-display text-3xl font-semibold leading-tight text-ink md:text-[2.75rem]" data-id="element-107" data-mp="2e06aoc06i507">
            Preguntas frecuentes
          </h2>
          <p className="mt-4 text-lg text-muted" data-id="element-108" data-mp="241qqkszkjw07">Todo lo que necesitás saber antes de empezar.</p>
        </div>

        <ul className="border-t border-line" data-id="element-109" data-mp="1z3ym6zhqmhf4">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          const id = `faq-panel-${i}`;
          return <li key={f.q} className="border-b border-line" data-id="element-110" data-mp="nnighxvzjf5g" data-mpi={i}>
                <h3 data-id="element-111" data-mp="nq4otzqp9yoq">
                  <button type="button" aria-expanded={isOpen} aria-controls={id} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-6 text-left text-lg font-bold text-ink focus:outline-none focus-visible:underline focus-visible:decoration-sun focus-visible:decoration-4" data-id="element-112" data-mp="phy05goxrvsb">
                    {f.q}
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-sun text-ink" : "bg-mint text-ink"}`} data-id="element-113" data-mp="6pdbyck6meuu">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-114" data-mp="3jxyjpih5dusy" />
                    </span>
                  </button>
                </h3>
                <div id={id} aria-hidden={!isOpen} className={`grid transition-[grid-template-rows,opacity,visibility] duration-[220ms] ease-out motion-reduce:transition-none ${isOpen ? "visible grid-rows-[1fr] opacity-100" : "invisible grid-rows-[0fr] opacity-0"}`} data-id="element-115" data-mp="3nyigum1q0yf3">
                  <div className="overflow-hidden" data-id="element-116" data-mp="1fsgk7miy8paj">
                    <p className="pb-6 pr-12 leading-relaxed text-muted" data-id="element-117" data-mp="1fpvh6u6x03b7">{f.a}</p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}